export default "__VITE_ASSET__X4Zl_ERb__"